module.exports = __webpack_public_path__ + "static/img/security_dialog_top.23b391b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/security_dialog_top.png
// module id = 2/CN
// module chunks = 1